import {
  ResourceContextProvider,
  SimpleForm,
  Title,
  useNotify,
} from "react-admin";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import BackButtonToolbar from "features/BackButtonToolbar";
import { dormitoryRequests } from "api/dormitoryApi";
import dataProvider from "server/dataProvider";
import { useNotifyError } from "utils/useNotifyError";
import { DormitoryServicePath, ROOM_TYPES, STATE_SUBSIDIES, SUBSIDIES } from "utils/constants";
import SaveForm from "../SaveForm";

const CreateStateSubsidy = () => {
  const notify = useNotify();
  const notifyError = useNotifyError();
  const navigate = useNavigate();
  const { typeId } = useParams();
  const roomTypeName = useLocation().state?.roomTypeName;

  const handleSubmit = async data => {
    try {
      await dataProvider.customRequest(
        dormitoryRequests.createStateSubsidy(typeId),
        {
          amount: data.amount,
          receptionTypeId: data.receptionTypeId,
          studentType: data.studentType,
          validFrom: data.validFrom,
          validTo: data.validTo,
        },
        "POST",
      );
      notify("Успешно създаване на държавна субсидия", { type: "success" });
      navigate(`/${DormitoryServicePath}${STATE_SUBSIDIES}`);
    } catch (err) {
      notifyError(err);
    }
  };

  return (
    <>
      <Title
        title={
          roomTypeName
            ? `Създаване на държавна субсидия: ${roomTypeName}`
            : "Създаване на държавна субсидия"
        }
      />
      <BackButtonToolbar />
      <ResourceContextProvider value={`${DormitoryServicePath}${ROOM_TYPES}/${typeId}/${SUBSIDIES}/create`}>
        <SimpleForm onSubmit={handleSubmit}>
          <SaveForm />
        </SimpleForm>
      </ResourceContextProvider>
    </>
  );
};

export default CreateStateSubsidy;
